import { PremiumPaymentPage } from './../premium/premium-payment/premium-payment';
import { Component, EnvironmentInjector, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Platform, LoadingController, NavController, ActionSheetController, ModalController, IonTabs } from '@ionic/angular';
import { CategoriesProvider } from '../../providers/categories/categories';
import { ConfigProvider } from '../../providers/config/config';
import { UserProvider } from '../../providers/user/user';
import { SessionProvider } from '../../providers/session/session';
import { ValueProvider } from '../../providers/value/value';
import { TutorialProvider } from '../../providers/tutorial/tutorial';
import { NewsController } from '../../providers/news/news-contoller';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { TournamentService } from '../apps/gamer/services/tournament.service';
import { GeolocationService } from '../../providers/geolocation-service/geolocation-service';
import { PremiumBannerPage } from '../premium/premium-banner/premium-banner';
import { Subscription } from 'rxjs';
import { DarkMode, ThemeMode } from '../../providers/dark-mode/dark-mode';
import { Router } from '@angular/router';
import { TutorialsComponent } from '../../components/tutorials/tutorials.component';
import { NavigationService } from '../../providers/navigation/navigation.service';

@Component({
  templateUrl: 'tabs.html',
  selector: 'tabs-main',
  styleUrls:['./tabs.scss']
})
export class TabsPage {
  displayMaps: boolean = false;
  lauftreffApp: boolean = false;
  tabsNews: boolean = false;
  onComeBack: boolean = false;
  newTouPage: boolean = true;
  seltabix: number = 0;
  views: any;
  appName: string = "";

  // darkmode
  toDarkSub:Subscription;
  isDark:boolean=false;

  // used to show/hide the tutorial only for hannover app
  // TODO SWITCH 
  firstrun: boolean = true;
  tutorial: boolean = false;
  tutorialForest: boolean = false;
  tutorial_page: number = 0;
  //

  //UI
  reloadTrigger: boolean = true;
  isHella: boolean = false;
  resultsPage: boolean = true;
  iconTrnName: string = "appname-training";
  iconRecName: string = "appname-record";
  iconMeName: string = "appname-me";
  iconTshirtNameBlue: string = "appname-tshirt";
  iconFieldBlue: string = "appname-field";
  currentPage: string;
  redirectPermission: boolean = true;
  isBrowser: boolean = false;

  // tab1Root: any = EventSearchPage;
  // tab2Root: any = MysportUserProfilePage;
  // tab3Root: any = ResultSearchPage;
  // tab4Root: any = TrackPage;
  // tab5Root: any = EventActivityTabsPage;
  // tab6Root: any = ResultTeamsPage;
  // tab7Root: any = NotificationPage;
  // tab8Root: any = LeaderTrack;
  // tab9Root: any = GamerTeamsPage;
  // tab10Root: any = LineupPage;
  // tab11Root: any = NewTouMainPage;
  // tab12Root: any = PlanResultsMainPage;
  // tab13Root: any = TouListPage;
  // tab14Root: any = AnmeldungenPage;

  selectedTab: number = 2;
  @ViewChild('mainTabs') tabRef: IonTabs;
  previousTab: string = 'tab1';

  constructor(
    private router:Router,
    private gs: TournamentService,
    public navCtrl: NavController,
    public translate: TranslateService,
    private userService: UserProvider,
    private platform: Platform,
    private config: ConfigProvider,
    private categoryService: CategoriesProvider,
    private loadingCtrl: LoadingController,
    public sessionService: SessionProvider,
    private valueService: ValueProvider,
    private tutorialProvider: TutorialProvider,
    private geoService: GeolocationService,
    private modalCtrl: ModalController,
    public appDetector: AppDetectorProvider,
    private darkModeService: DarkMode,
    public environmentInjector: EnvironmentInjector,
    private navService:NavigationService
  ) {
    console.log('tabsPage')
    console.log(this.appDetector)
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    new Promise(async (resolve, reject) => {
      this.appName = (await this.config.config).appId;
      // this.isBrowser = (await this.config.config).platform.browser;
      this.lauftreffApp = (await this.config.config).showHide.lauftreff;
      this.tabsNews = (await this.config.config).showHide.tabsNews;
      this.tutorial = (await this.config.config).showHide.hannoverTutorial;
      this.tutorialForest = (await this.config.config).showHide.tutorialForest;
      console.log('tutorialForest', (await this.config.config).showHide.tutorials)
      this.resultsPage = (await this.config.config).showHide.resultsPage;

      this.redirectPermission = (await this.config.config).showHide.redirectPermission;
      this.newTouPage = !!!this.gs.planList.length;
      this.onComeBack = state["onComeBack"];
      this.seltabix = state["openTab"];
      this.views = state["views"];

      this.isHella = this.appName.includes("hella") ? true : false;
      this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";

      const tutorials = (await this.config.config).showHide.tutorials || { isEnabled: false, size: 0 };
      this.tutorialProvider.isFirstRun().then(data => {
        console.log('firstrun', data)
        this.firstrun = data;
        if(this.firstrun && tutorials.isEnabled){
          this.openTutorialModal(tutorials);
        }
        resolve(null);
      });
      resolve(null);
    });
  }
  ngOnInit() {
    this.toDarkSub = this.darkModeService.themeModeSubject.subscribe((mode: ThemeMode) => {
      this.isDark = (mode === ThemeMode.DarkMode);
      let body = <HTMLElement>document.querySelector('body');

      if (this.isDark && !body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.add(ThemeMode.DarkMode);
      } else if (!this.isDark && body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.remove(ThemeMode.DarkMode);
      }
    });
  }
  async openTutorialModal(tutorials) {
    // const tutorials = (await this.config.config).showHide.tutorials || { isEnabled: false, size: 0 };
    const modal = await this.modalCtrl.create({
      component: TutorialsComponent,
      cssClass: 'tutorial-modal',
      backdropDismiss: false,
      componentProps: { tutorials: tutorials } 
    });
      
    await modal.present();
  }
  onTabChange(event: any) {
    console.log('click tab change')
    this.previousTab = event.tab;
    console.log('event.tab', event.tab, event)
    this.navService.pushToHistory(`/${event.tab}`)
  }

  async preloadClientData() {
    let loader = await this.loadingCtrl.create({
      message: this.translate.instant('GLOBAL_LOADING')
    });

    loader.present();

    this.valueService.getProfileBackgrounds().then(backgrounds => {

      NewsController.getInstance().isAllowed = false;
      this.navCtrl.navigateForward('/mysport-user-profile', {state:{data: { profile: this.sessionService.profile, backgrounds: backgrounds }}})
      // (this.app.getActiveNav() as NavController)
      //   .push(MysportUserProfilePage, {
      //     data: { profile: this.sessionService.profile, backgrounds: backgrounds }
      //   })
        .then(() => loader.dismiss());
    });
  }

  tapped() {
    const url = this.router.url;
    console.log('Current URL:', url);
    const segments = url.split('/');
    const currentView = segments[segments.length - 1];
    // let view = this.app.getActiveNav().getViews()[0].name;
  }

  reload() {
    this.reloadTrigger = false;
    setTimeout(() => {
      this.reloadTrigger = true
    });
  }

  onLoadMap() {
    // this.navCtrl.setPages(this.views);
    // this.navCtrl.pop();
    if (this.views && this.views.length > 0) {
      const lastView = this.views[this.views.length - 1];
      this.navCtrl.navigateForward(lastView, { replaceUrl: true });
    } else {
      this.navCtrl.back();
    }
  }

  ngAfterViewInit() {
    this.platform.ready().then(async() => {
      this.config.config.then(config => {
        this.displayMaps = config.showHide.liveMaps;
      });

      this.sessionService.onRequestPageLogin().subscribe((promise) => {
        this.showLogin(promise);
      });

      this.sessionService.onRequestLogout().subscribe(() => {
        this.updateMeIcon();
        this.geoService.stopPlugin();
      });

      this.sessionService.onRequestLoggedIn().subscribe(() => {
        this.updateMeIcon();
      });

      this.gs.$planListChangeSub.subscribe(() => {
        console.log('-----planListChangeSub-----');
        this.newTouPage = !!!this.gs.planList.length;
        this.reload();
        setTimeout(() => {
          // this.app.getRootNav().getActiveChildNav().select(1);
          this.navCtrl.navigateForward('/tab1');
          console.log('-----redirect to the tab(1)-----');
        }, 50);
      });

      this.sessionService.onRequestPageProfileEdit().subscribe(async () => {

        if (!this.redirectPermission) return;
        // let l = (this.app.getRootNav() as NavController).getViews();
        // if (l.find(x => x.component === PrivateProfilePage)) return;
        if (this.router.url.includes('private-profile')) {
          return;
        }

        let loader = await this.loadingCtrl.create({
          message: this.translate.instant('GLOBAL_LOADING')
        });
        loader.present();

        Promise.all([
          this.valueService.getProfileTitles(),
          this.valueService.getProfileTypes(),
          this.valueService.getCountries(),
          this.categoryService.getEventCategoires(),
          this.valueService.getProfileBackgrounds()
        ]).then(values => {
          const targetUrl = '/tab2/me/settings/private-profile'
          if (!this.router.url.includes(targetUrl)) {
            this.navCtrl.navigateForward(targetUrl, {state:{
              data: {
                titles: values[0],
                types: values[1],
                countries: values[2],
                categories: values[3],
                photos: [],
                backgrounds: values[4],
                profile: this.sessionService.profile
              }
            }})
            .then(() => loader.dismiss());
          }
        });
      });

      let loader = await this.loadingCtrl.create();
      loader.present();
      Promise.all([this.categoryService.getAllCategories(), this.userService.checkLoged()]).then(() => {
        if (this.appDetector.isLeaderBoardApp()) this.navCtrl.navigateForward('/tab1'); //this.app.getRootNav().getActiveChildNav().select(0);
        loader.dismiss();
      });
    });

    //this.config.urlConfig().then((data) => console.log(data));
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  showLogin(promise = { resolve: null }) {
    if (this.isHella) {
      // IdRegistrationPage ORIGINAL_RETURN
      // this.app.getRootNav().push(IdRegistrationPage);
      this.navCtrl.navigateForward('/auth/id-registration');
    } else if(this.appDetector.isEventsApp()&&!this.appDetector.isForestApp()) {
      this.navCtrl.navigateForward('/auth/login')
      this.sessionService.setPostLoginAction(()=>{
        promise.resolve()
      })
    }else{
      this.navCtrl.navigateForward('/auth/login')
      this.sessionService.setPostLoginAction(()=>{
        promise.resolve()
      })
    }
  }

  getFirstRun() {
    return this.firstrun;
  }

  ionViewWillLeave() {
    this.onComeBack = false;

    this.reload();
  }

  fillTrnIcon() {
    if (!this.tutorialProvider.isLoginAllowed) {
      this.iconTrnName = this.appDetector.isLeaderBoardApp() ? "appname-training-filled-blue" : "appname-training-filled";
      return;
    }
    console.log('this.sessionService.isLoged', this.sessionService.isLoged)
    if (!this.sessionService.isLoged) {
      console.log('log',!this.sessionService.isLoged)
      this.sessionService.getToken(false, false).then(async(token) => {
        if(token){
          await this.navCtrl.navigateForward(`/tab5`);
        }else{
          this.navCtrl.navigateForward('/auth/login');
          this.sessionService.setPostLoginAction(()=>{
            this.fillTrnIcon()
          })
        }
      })
    } else {
      // TEMPORARY FIX 2 -> 3
      // this.app.getRootNav().getActiveChildNav().select(3);
      this.navCtrl.navigateForward('/tab5');
    }

    this.iconTrnName = this.appDetector.isLeaderBoardApp() ? "appname-training-filled-blue" : "appname-training-filled";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconRecName = "appname-record";
    this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";

    this.iconFieldBlue = "appname-field";
  }

  updateMeIcon() {
    let iconElement;
    if (this.platform.is('android')) {
      iconElement = document.getElementsByClassName('ion-md-appname-me')[0];
      if (typeof iconElement === "undefined") {
        let className = (this.appDetector.isForestApp()) ? "ion-md-appname-me-filled-green" : this.appDetector.isGesunderApp() ? "ion-md-appname-me-filled-black" : "";
        iconElement = document.getElementsByClassName(className)[0];
      }
    } else if (this.platform.is('ios')) {
      iconElement = document.getElementsByClassName('ion-ios-appname-me-outline')[0];
      if (typeof iconElement === "undefined") {
        let className = (this.appDetector.isForestApp()) ? "ion-ios-appname-me-filled-green" : this.appDetector.isGesunderApp() ? "ion-ios-appname-me-filled-black" : "";
        iconElement = document.getElementsByClassName(className)[0];
      }
    }
    iconElement = document.getElementsByClassName('user-image-m')[0];
    if (typeof iconElement !== "undefined") {
      if (this.sessionService.isLoged) {
        iconElement.style.background = "url(" + (this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png') + ") no-repeat";
        iconElement.style.height = "28px";
        iconElement.style.width = "28px";
        iconElement.style.borderRadius = "50px";
        iconElement.style.backgroundSize = "cover";
        iconElement.style.backgroundPosition = "center";
      }
      else {
        iconElement.style.background = "";
        iconElement.style.height = "";
        iconElement.style.width = "";
        iconElement.style.borderRadius = "";
        iconElement.style.backgroundSize = "";
        iconElement.style.backgroundPosition = "";
      }
    }
  }

  fillRecIcon() {
    if (!this.tutorialProvider.isLoginAllowed) {
      this.iconRecName = (this.appDetector.isTournamentApp() || this.appDetector.isLeaderBoardApp()) ? "appname-record-filled-blue" : "appname-record-filled";
      return;
    }
    
    if (this.sessionService.isLoged && this.appDetector.isLeaderBoardApp()) {
      this.navCtrl.navigateForward('/tab2');
    } else if (this.sessionService.isLoged && this.appDetector.isForestApp()) {
      this.navCtrl.navigateForward('/tab4');
      this.presentPremiumPage();
    }else if(this.appDetector.isTournamentApp()){
      this.sessionService.getToken(false, false).then(async(token) => {
        if(token){
          this.gs.getPlanList().then((t) => {
            this.newTouPage = !!!this.gs.planList.length;
            this.navCtrl.navigateForward('/tab4');
          });
        }else{
          this.navCtrl.navigateForward('/auth/login');
          this.sessionService.setPostLoginAction(()=>{
            this.fillRecIcon()
          })
        }
      })
    } else {
      this.sessionService.getToken(false, false).then(async(token) => {
        if(token){
           let pageIndex = this.appDetector.isForestApp() ? 4 : 2;
            this.navCtrl.navigateForward(`/tab${pageIndex}`);
            if(pageIndex==4){
              this.presentPremiumPage();
            }
        }else{
          this.navCtrl.navigateForward('/auth/login');
          this.sessionService.setPostLoginAction(()=>{
            this.fillRecIcon()
          })
        }
      })
      // this.navCtrl.navigateForward('/auth/login');
    }


    this.iconRecName = (this.appDetector.isTournamentApp() || this.appDetector.isLeaderBoardApp()) ? "appname-record-filled-blue" : "appname-record-filled";
    this.iconTrnName = "appname-training";
    this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";
    this.iconFieldBlue = "appname-field";
    this.iconTshirtNameBlue = "appname-tshirt";
  }

  async presentPremiumPage() {
    if (this.sessionService.isLoged && this.sessionService.profile && this.sessionService.profile.premium) return;

    let modalCtrl = await this.modalCtrl.create({component:PremiumBannerPage});

    modalCtrl.present();
    modalCtrl.onDidDismiss().then(async (res) => {
      console.log('res', res)
      if (res.data) {
        let newModal = await this.modalCtrl.create({component:PremiumPaymentPage});
        newModal.present();
      }
    });
  }

  fillMeIcon() {
    // this.iconMeName = (this.appDetector.isForestApp()) ? "appname-me-filled-green" : this.appDetector.isGesunderApp() ? "appname-me-filled-black" : "";
    // this.iconMeName = (this.appDetector.isForestApp()) ? "appname-me-filled-green" : this.appDetector.isGesunderApp() ? "appname-me-filled-black" : "";
    if (this.appDetector.isForestApp()) {
      this.iconMeName = "beard-me";
    } else if (this.appDetector.isGesunderApp()) {
      this.iconMeName = "appname-me-filled-black";
    } else if (this.appDetector.isTournamentApp() || this.appDetector.isLeaderBoardApp()) {
      this.iconMeName = "appname-me-filled-blue";
    }
    this.iconTrnName = "appname-training";
    this.iconRecName = "appname-record";
    this.iconFieldBlue = "appname-field";
    this.iconTshirtNameBlue = "appname-tshirt";
  }

  fillTshirtIcon() {
    this.iconTshirtNameBlue = "appname-tshirt-filled-blue";
    this.iconTrnName = "appname-training";
    this.iconMeName = "appname-me";
    this.iconFieldBlue = "appname-field";
    this.iconRecName = "appname-record";
    if (this.appDetector.isTournamentApp()) {
      this.sessionService.getToken(false, false).then(async(token) => {
        if(token){
          this.gs.getPlanList().then((t) => {
            this.newTouPage = !!!this.gs.planList.length;
            // this.app.getRootNav().getActiveChildNav().select(2);
            this.navCtrl.navigateForward('/tab2');
          });
        }else{
          this.navCtrl.navigateForward('/auth/login');
          this.sessionService.setPostLoginAction(()=>{
            this.fillTshirtIcon()
          })
        }
      })
    }
  }

  fillFieldIcon() {
    this.iconFieldBlue = 'appname-field-filled';
    this.iconTrnName = "appname-training";
    this.iconMeName = "appname-me";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconRecName = "appname-record";
    if (this.appDetector.isTournamentApp()) {
      this.sessionService.getToken(false, false).then(async(token) => {
        if(token){
          this.gs.getPlanList().then((t) => {
            this.newTouPage = !!!this.gs.planList.length;
            // this.app.getRootNav().getActiveChildNav().select(3);
            this.navCtrl.navigateForward('/tab3');
          });
        }else{
          this.navCtrl.navigateForward('/auth/login');
          this.sessionService.setPostLoginAction(()=>{
            this.fillFieldIcon()
          })
        }
      })
    }
  }

  setIconsDefault() {
    this.iconTrnName = "appname-training";
    this.iconRecName = "appname-record";
    this.iconMeName = this.appDetector.isForestApp() ? "beard-me" : "appname-me";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconFieldBlue = "appname-field";

    this.updateMeIcon();
  }

  touListTabPressed() {
    this.iconTrnName = "appname-training";
    this.iconRecName = "appname-record";
    this.iconMeName = "appname-me";
    this.iconTshirtNameBlue = "appname-tshirt";
    this.iconFieldBlue = "appname-field";

    this.updateMeIcon();
    if (this.appDetector.isTournamentApp()) {
      this.sessionService.getToken(false, false).then(async(token) => {
        if(token){
          this.gs.getPlanList().then((t) => {
            this.newTouPage = !!!this.gs.planList.length;
            // this.app.getRootNav().getActiveChildNav().select(1);
            this.navCtrl.navigateForward('/tab1');
          });
        }else{
          this.navCtrl.navigateForward('/auth/login');
          this.sessionService.setPostLoginAction(()=>{
            this.touListTabPressed()
          })
        }
      })
    }
  }

  setEventsTab() {
    this.selectedTab = 0;
    this.loginGuard();
    this.setIconsDefault();
  }

  setErgenisseTab() {
    this.selectedTab = 1;
    this.loginGuard();
    this.setIconsDefault();
  }

  loginGuard() {
    if (!this.sessionService.isLoged) {
      // this.app.getRootNav().push(LoginPage, { selectedTab: this.selectedTab });
      this.navCtrl.navigateForward('/auth/login', {state:{selectedTab: this.selectedTab}});
      setTimeout(() => {
        if (this.tabRef && this.previousTab) {
          this.tabRef.select(this.previousTab);
        }
      })
      return;
    }
  }
}
